/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantAdminRoleAssignmentResponse {
    getFixupPrototypeFunction() { return TenantAdminRoleAssignmentResponse.fixupPrototype; }

    static newInstance(model: Partial<TenantAdminRoleAssignmentResponse>): TenantAdminRoleAssignmentResponse {
        let obj = Object.assign(new TenantAdminRoleAssignmentResponse(), model);
        TenantAdminRoleAssignmentResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantAdminRoleAssignmentResponse>): TenantAdminRoleAssignmentResponse {
        if (!model) return null;
        return TenantAdminRoleAssignmentResponse.newInstance(<TenantAdminRoleAssignmentResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantAdminRoleAssignmentResponse) {
        if (!obj) return;

        models.TenantAdminRoleAssignmentResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantAdminRoleAssignmentResponse): boolean {
        Object.setPrototypeOf(obj, TenantAdminRoleAssignmentResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the updated User
     */
    user_id: string;

    /**
     * Status of user
     */
    status: models.UserStatus;

}
